import gql from 'graphql-tag';
import { kmsClient } from 'api/apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  AccountsOverviewUpdateCampaignNotesMutation,
  AccountsOverviewUpdateCampaignNotesMutationVariables
} from './__generated__/AccountsOverviewUpdateCampaignNotesMutation';

export const ACCOUNTS_OVERVIEW_UPDATE_CAMPAIGN_NOTES_MUTATION = gql`
  mutation AccountsOverviewUpdateCampaignNotesMutation(
    $id: ID!
    $notes: String
    $lastModifiedNotesAt: String
    $lastModifiedNotesBy: String
  ) {
    accountsOverviewUpdateCampaignNotes(
      id: $id
      notes: $notes
      lastModifiedNotesAt: $lastModifiedNotesAt
      lastModifiedNotesBy: $lastModifiedNotesBy
    ) {
      success
      errors
    }
  }
`;

export const useAccountsOverviewUpdateCampaignNotesMutation = () => {
  return useMutation<AccountsOverviewUpdateCampaignNotesMutation, AccountsOverviewUpdateCampaignNotesMutationVariables>(
    ACCOUNTS_OVERVIEW_UPDATE_CAMPAIGN_NOTES_MUTATION,
    { client: kmsClient }
  );
};
